import { InputAdornment, TextField, Typography } from "@material-ui/core";
import React from "react";

export default function EditableTypography({
  edit,
  prefix,
  suffix,
  name,
  onChange,
  multiline,
  style,
  children,
  type,
}) {
  return edit ? (
    <TextField
      value={children}
      prefix={prefix}
      type={type}
      fullWidth
      onChange={onChange}
      label={name}
      multiline={multiline}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">{prefix}</InputAdornment>
        ),
        endAdornment: <InputAdornment position="end">{suffix}</InputAdornment>,
      }}
    ></TextField>
  ) : (
    <Typography style={style || { whiteSpace: "pre-wrap" }}>
      {prefix}
      {children}
      {suffix}
    </Typography>
  );
}
